export default __webpack_public_path__ + "static/media/cor.dc255e07.svg";